import { forwardRef, ForwardRefRenderFunction } from "react";
//#region types
import { BaseFormComponentProps, FormHandles } from "models/propTypes/genericFormProps";
import { DocumentFormTypes, UtilFormTypes } from "models/formTypes";
import { TranslationKeys } from "translations";
import { StyleEnums } from "models/enums";
//#endregion
//#region components
import ExportSIEForm from "./exportSIEForm";
import useSieCreateFormHelper from "./useCreateFormHelper";
import { useFloatingMessages } from "components/common";
import { useLoggingService, useDocumentService } from "serviceHooks";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

const ExportSIEFormContainer: ForwardRefRenderFunction<FormHandles, BaseFormComponentProps> = (props, ref) => {
  const loggingService = useLoggingService();
  const documentService = useDocumentService();
  const sieFile = {} as DocumentFormTypes.ExportSIE;

  const { financialYears, validationSchema } = useSieCreateFormHelper();
  const { enqueueMessage } = useFloatingMessages();

  const handleFormSubmit = (values: DocumentFormTypes.ExportSIE) => {
    let dateRange: UtilFormTypes.DateRange | undefined = undefined;

    if (values.financialYear) {
      dateRange = financialYears.find((f) => f.id === values.financialYearId)?.data;
    } else if (values.dateRange?.start !== undefined && values?.dateRange.end !== undefined) {
      dateRange = { start: values.dateRange.start, end: values.dateRange.end };
    }

    if (dateRange && dateRange?.start && dateRange?.end) {
      return documentService.exportSIEFilePost({ startDate: dateRange.start, endDate: dateRange.end });
    }

    logErrorInDateRange("handleFormSubmit", dateRange);
    return Promise.reject();
  };

  const logErrorInDateRange = (errorLocation: string, dateRange: UtilFormTypes.DateRange | undefined) => {
    const err = new Error();
    Error.captureStackTrace(err);
    const message = `Unexpected error occured in exportSIEFormContainer (${errorLocation}). dateRange?.start: ${dateRange?.start} - dateRange?.end ${dateRange?.end}`;

    loggingService.logError(message, err.stack ?? "No stack trace available");

    enqueueMessage(
      LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Errors.ErrorBoundaryMessage),
      StyleEnums.DisplayType.Danger
    );
  };

  return (
    <ExportSIEForm
      ref={ref}
      validationSchema={validationSchema}
      defaultValues={sieFile}
      handleSubmit={handleFormSubmit}
      onFormValidationChange={props.onFormValidationChange}
      financialYears={financialYears}
    />
  );
};

export default forwardRef(ExportSIEFormContainer);
